import React from "react";
import Nav from "../components/Nav";

const sections = [
  {
    title: "Information we collect",
    items: [
      "Personal information you provide: name, email address, phone number, and project details when you contact us via the contact form.",
      "Usage data: pages visited, time spent, referral source, and similar analytics collected via Google Analytics (GA4).",
      "Communication data: correspondence sent to hello@labradical.com.au or through the SiteChat widget.",
    ],
  },
  {
    title: "How we use your information",
    items: [
      "To respond to enquiries and provide quotes for our services.",
      "To improve our website and understand how visitors interact with it.",
      "To send occasional follow-ups if you've expressed interest in our services (you can opt out at any time).",
    ],
  },
  {
    title: "Data sharing",
    items: [
      "We do not sell your personal information.",
      "We share data only with trusted third-party services necessary to run our business: Google Analytics (analytics), Resend (email delivery), and Netlify (hosting).",
      "We may disclose information if required by law or to protect our legal rights.",
    ],
  },
  {
    title: "Data storage and security",
    items: [
      "Your data is stored securely on servers located in Australia and the United States, depending on the service used.",
      "We take reasonable measures to protect your data, but no internet transmission is completely secure.",
    ],
  },
  {
    title: "Your rights",
    items: [
      "Access, correct, or delete your personal data by emailing hello@labradical.com.au.",
      "Opt out of Google Analytics tracking by installing the Google Analytics Opt-out Browser Add-on.",
      "Withdraw consent for email communications at any time by replying 'unsubscribe'.",
    ],
  },
  {
    title: "Cookies",
    items: [
      "We use minimal cookies for analytics and site functionality.",
      "Google Analytics uses cookies to track usage patterns. These are anonymised where possible.",
      "You can control cookie preferences through your browser settings.",
    ],
  },
  {
    title: "Changes to this policy",
    items: [
      "We may update this policy from time to time. Changes will be posted on this page with an updated effective date.",
    ],
  },
];

export default function Privacy() {
  return (
    <div className="bg-bg min-h-screen text-text">
      <Nav />
      <div className="container mx-auto max-w-3xl px-6 py-20">
        <h1 className="font-heading text-[clamp(28px,4vw,40px)] font-bold leading-tight -tracking-[0.03em]">
          Privacy Policy
        </h1>
        <p className="mt-3 text-[14px] text-muted">
          Effective: 17 June 2026
        </p>
        <p className="mt-6 text-[14px] font-light leading-[1.75] text-muted">
          lab.radical ("we", "our", "us") operates the website labradical.com.au
          and provides design and automation services. This policy explains how
          we collect, use, and protect your personal information.
        </p>

        {sections.map((section, i) => (
          <div key={i} className="mt-12">
            <h2 className="font-heading text-[18px] font-bold -tracking-[0.02em]">
              {i + 1}. {section.title}
            </h2>
            <ul className="mt-4 list-disc space-y-2 pl-5 text-[14px] font-light leading-[1.7] text-muted">
              {section.items.map((item, j) => (
                <li key={j}>{item}</li>
              ))}
            </ul>
          </div>
        ))}

        <div className="mt-16 border-t border-border pt-8">
          <p className="text-[13px] text-muted">
            Questions? Email{" "}
            <a
              href="mailto:hello@labradical.com.au"
              className="text-lime underline transition-opacity hover:opacity-80"
            >
              hello@labradical.com.au
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
